var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"services-page"},[_c('ServicesSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }